import React, { useState, useEffect } from 'react';

import Button from '../Button/Button';
import { trackEvent } from '../../services/analyticsService';

import styles from './index.module.scss';

import prizes_img_url from '../../assets/images/premi-friends.png';

const STORE_PLATFORM_URL = 'https://friends.c1-p8.com/store_final.json';

export interface StoreItem {
  id: number;
  title: string;
  city: string;
  mcdid: string;
  url?: string;
  address?: string;
}

interface StoreSearchProps {
  type?: 'default' | 'simple' | 'full';
  onSearchSubmit?: (results: StoreItem[]) => void;
}

const StoreSearch: React.FC<StoreSearchProps> = ({ type = 'default', onSearchSubmit }) => {
  const [allStores, setAllStores] = useState<StoreItem[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await fetch(STORE_PLATFORM_URL);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        const sites: StoreItem[] = (data.sites || []).map((s: any) => ({
          id: s.id,
          title: s.title || '',
          city: s.city || '',
          mcdid: String(s.mcdid ?? ''),
          url: s.url,
          address: s.address,
        }));
        setAllStores(sites);
      } catch (err) {
        console.error('Errore nel caricamento degli store:', err);
        setError('Impossibile caricare la lista dei ristoranti. Riprova più tardi.');
      } finally {
        setLoading(false);
      }
    };
    fetchStores();
  }, []);

  const getFilteredStores = (): StoreItem[] => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return allStores;
    const wordStartsWith = (text: string) =>
      text.split(/\s+/).some((word) => word.toLowerCase().startsWith(q));
    return allStores.filter(
      (store) =>
        // (store.title && wordStartsWith(store.title)) ||
        // (store.address && wordStartsWith(store.address)) ||
        (store.city && wordStartsWith(store.city))
    );
  };

  const handleCercaClick = () => {
    trackEvent('Store Search', 'Store Search - Click');
    const results = getFilteredStores();
    onSearchSubmit?.(results);
  };

  return (
    <div>
      <h2 className={styles.Title}>
        McDONALD'S ADERENTI
      </h2>
      <div className={styles.Content}>
        <p>
          Cerca il McDonald's<br />
          più vicino a te<br />
          per partecipare al Quiz!
        </p>
        {error && <p className={styles.error}>{error}</p>}
        <label htmlFor="store-search">Inserisci una Città</label>
        <input
          type="text"
          id="store-search"
          placeholder="Cerca città"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          disabled={loading}
          autoComplete="off"
        />
        <Button
          size="small"
          color="primary"
          type="button"
          onClick={handleCercaClick}
          disabled={loading || searchQuery.trim().length < 2}
        >
          Cerca
        </Button>
        <div className={styles.prizesImgWrapper}>
          <p>Premi:</p>
          <img src={prizes_img_url} alt="Premi Friends" />
        </div>
        {/* <p className={styles.small}>
          La lista è in continuo aggiornamento.<br />
          Verifica la disponibilità<br/>
          sul tuo McDonald's preferito.
        </p> */}
      </div>
    </div>
  );
};

export default StoreSearch;
